import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { CustomerSearchModel } from "../../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";
import { CustomerSearchResult } from "../../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchResult";
import { ITableConfig, Table } from "../../../../../../Shared/Table/Table";
import { Urls } from "../../../../../Urls";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import AriaTooltip from "../../../../../../Shared/Tooltip/AriaTooltip";
import { CustomerSearchAction } from "../../../ClientRecord/Action/CustomerSearchAction";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { PortfolioDashboardAction } from "../../../PortfolioDashboard/Action/PortfolioDashboardAction";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";

interface ICustomerMatchingProps {
    data: CustomerSearchModel;
    onPageChange: (pageIndex, pageSize) => void;
    onDismissMatches: () => void;
    displayChooseClientOption: boolean;
    onClientChosen?: (customerId: number) => void;
    isLoading?: boolean;
}

interface ICustomerMatchingState {
    currentPage: number;
    customerAge: string;
    taxIdentifier: string;
    postCode: string;
    emailAddress: string;
    showDismissPopUp: boolean;
    showRedirectionPopUp: boolean;
    selectedCustomerId: number;
    showChooseClientPopUp: boolean;
    isLoading?: boolean;
}

export class CustomerMatching extends FormComponent<ICustomerMatchingProps, ICustomerMatchingState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentPage: 1,
            customerAge: "0",
            taxIdentifier: "",
            postCode: "",
            emailAddress: "",
            showDismissPopUp: false,
            showRedirectionPopUp: false,
            selectedCustomerId: 0,
            showChooseClientPopUp: false,
            isLoading: true,
        };
    }

    private getCustomerDetail(customerId: number) {
        this.setState({ isLoading: true });
        CustomerSearchAction.getCustomerData(customerId, (result) => {
            let customerAge,
                taxIdentifier,
                postCode,
                emailAddress = "Not held";
            if (result?.CustomerTaxResidencyDetails != null && result?.CustomerTaxResidencyDetails.length > 0) {
                taxIdentifier = result?.CustomerTaxResidencyDetails[0].TaxReference;
            }
            if (result?.EmailAddressDetails != null && result?.EmailAddressDetails.length > 0) {
                emailAddress = result?.EmailAddressDetails[0].EmailAddress;
            }
            const residentialAddreses =
                result?.AddressDetails != null
                    ? result?.AddressDetails.filter((x) => x.PhysicalAddressType == PhysicalAddressType.Residential)
                    : null;

            if (residentialAddreses != null && residentialAddreses.length > 0) {
                postCode = result?.AddressDetails[0].Address.PostCode;
            }
            if (result?.PersonalDetails?.DateOfBirth != null) {
                customerAge = JsonDateParser.calculateAge(result?.PersonalDetails.DateOfBirth).toString();
            }

            this.setState({
                customerAge: customerAge,
                taxIdentifier: taxIdentifier,
                postCode: postCode,
                emailAddress: emailAddress,
                isLoading: false,
            });
        });
    }

    private navigateToClientPortfolio(customerId: number) {
        PortfolioDashboardAction.getAccountRoleWithAccountDetails(customerId, (accountRoles) => {
            if (
                accountRoles != null &&
                accountRoles.AccountRoles.some(
                    (x) =>
                        x.AccountRoleType == RoleType.IndividualAccountHolder ||
                        x.AccountRoleType == RoleType.JointAccountHolder ||
                        x.AccountRoleType == RoleType.Settlor
                )
            ) {
                if (checkPermission(UserClaim.AdviserPortalClientSummaryCanView))
                    {Navigator.navigateTo(
                        Urls.get().main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
                        }).summary
                    );}
            } else {
                if (checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView))
                    {Navigator.navigateTo(
                        Urls.get().main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
                        }).activity
                    );}
            }
        });
    }

    private renderTable() {
        const tooltipConfig = () => {
            return [
                { title: "Client age", data: this.state.customerAge },
                {
                    title: (
                        <span>
                            Tax /<br />
                            Government Identifier
                        </span>
                    ),
                    data: this.state.taxIdentifier,
                },
                { title: "Post code", data: this.state.postCode },
                { title: "Email address", data: this.state.emailAddress },
            ];
        };

        const col: ITableConfig[] = [
            {
                title: "Customer ID",
                key: "CustomerId",
            },
            { title: "First name(s)", key: "FirstName" },
            { title: "Surname", key: "LastName" },
            {
                title: "Date of birth",

                render: (data, row: CustomerSearchResult) => {
                    return (
                        <AriaTooltip
                            cssWrapper="is-underlined-text no-border-radius"
                            buttonText={JsonDateParser.getFormatDate(row.DateOfBirth, "dd/MM/yyyy")}
                            onClick={() => {
                                this.getCustomerDetail(row.CustomerId);
                            }}
                            onClose={() => {
                                this.setState({ taxIdentifier: "", postCode: "", emailAddress: "" });
                            }}
                            isLoading={this.state.isLoading}
                        >
                            <Typography type="auto-width" wrapCss="mt-10 mb-0" config={tooltipConfig()} />
                        </AriaTooltip>
                    );
                },
            },
            {
                title: "Date created",
                key: "DateCreated",
                render: (data) => {
                    return <>{JsonDateParser.getFormatDate(data, "dd/MM/yyyy")}</>;
                },
            },
            {
                title: "",
                key: "CustomerId",
                render: (data) => {
                    return (
                        <a
                            className="hyperlink"
                            onClick={() => this.setState({ showRedirectionPopUp: true, selectedCustomerId: data })}
                        >
                            Go to client
                        </a>
                    );
                },
            },
        ];

        if (this.props.displayChooseClientOption == true) {
            col.push({
                title: "",
                key: "CustomerId",
                render: (data) => {
                    return (
                        <a
                            className="hyperlink"
                            onClick={() => this.setState({ showChooseClientPopUp: true, selectedCustomerId: data })}
                        >
                            Use this client
                        </a>
                    );
                },
            });
        }

        return (
            <Table
                data={this.props.data.CustomerList}
                col={col}
                showEmptyMsg
                cssWrapper="mb-60"
                needPagination={{
                    totalNumOfResult: this.props.data.TotalNumberOfResults,
                    onPaginationChange: (pageIndex, pageSize) => {
                        this.setState({ currentPage: pageIndex });
                        this.props.onPageChange(pageIndex, pageSize);
                    },
                    currentPage: this.state.currentPage,
                }}
            />
        );
    }
    render() {
        return (
            <>
                <p>Existing client(s) with similar details have been identified.</p>
                {this.renderTable()}
                <div className="row row-center">
                    <button className="btn primary" disabled={false} onClick={() => this.props.onDismissMatches()}>
                        Dismiss matches
                        <span className="icon" aria-hidden="true"></span>
                    </button>
                </div>
                {this.state.showRedirectionPopUp && (
                    <Lightbox
                        show={this.state.showRedirectionPopUp}
                        title={"Confirmation"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showRedirectionPopUp: false })}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>
                            If you wish to view this client record, you lose the information you have entered during
                            this process.
                        </p>
                        <p className="mb-30">Are you sure you want to view this client record?</p>
                        <div className="row row-center">
                            <button
                                className="btn secondary mr-20"
                                onClick={() => this.setState({ showRedirectionPopUp: false })}
                            >
                                No
                            </button>
                            <button
                                className="btn primary"
                                onClick={() => this.navigateToClientPortfolio(this.state.selectedCustomerId)}
                            >
                                Yes
                            </button>
                        </div>
                    </Lightbox>
                )}
                {this.state.showChooseClientPopUp && (
                    <Lightbox
                        show={this.state.showChooseClientPopUp}
                        title={"Confirmation"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showChooseClientPopUp: false })}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>
                            If you wish to use this client record instead, you lose the information you have entered
                            during this process. Are you sure you want to continue?
                        </p>
                        <div className="row row-center">
                            <button
                                className="btn secondary mr-20"
                                onClick={() => this.setState({ showChooseClientPopUp: false })}
                            >
                                No
                            </button>
                            <button
                                className="btn primary"
                                onClick={() => this.props.onClientChosen(this.state.selectedCustomerId)}
                            >
                                Yes
                            </button>
                        </div>
                    </Lightbox>
                )}
                {this.state.showDismissPopUp && (
                    <Lightbox
                        show={this.state.showDismissPopUp}
                        title={"Confirmation"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showDismissPopUp: false })}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>Are you sure you want to dismiss this client record?</p>
                        <div className="row row-center">
                            <button
                                className="btn secondary mr-20"
                                onClick={() => this.setState({ showDismissPopUp: false })}
                            >
                                No
                            </button>
                            <button className="btn primary" onClick={() => this.props.onDismissMatches()}>
                                Yes
                            </button>
                        </div>
                    </Lightbox>
                )}
            </>
        );
    }
}
